import { createContext, type ReactNode } from 'react';

export interface HeaderActionsContextValue {
  setActions: (node: ReactNode) => void;
  clearActions: () => void;
}

export const HeaderActionsContext = createContext<HeaderActionsContextValue>({
  setActions: () => {},
  clearActions: () => {},
});
